import React from 'react';

import type { Html as HtmlBlockType } from '@/blocks/html';

interface IHtmlBlock {
  block: HtmlBlockType;
}

export const HtmlBlock: React.FC<IHtmlBlock> = ({ block }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: block.html }}
      className="flex h-full w-full justify-center"
    />
  );
};
